export const defaultPlanId = "free"

export interface PricingPlan {
  id: string
  name: string
  description: string
  price: string
  priceIntervalName: string
  stripe_price_id: string | null
  stripe_price_id_annual?: string | null
  stripe_product_id?: string
  features: string[]
  studentPlan?: boolean
  displayPrice?: string
  displayName?: string
  recommended?: boolean
}

export const pricingPlans: PricingPlan[] = [
  {
    id: "free",
    name: "Free",
    description: "Perfect for getting started with interview prep",
    price: "$0",
    priceIntervalName: "per month",
    stripe_price_id: null,
    features: [
      "5 AI-powered interviews/month",
      "Basic feedback reports",
      "Community access",
      "Interview question bank access",
    ],
    studentPlan: true,
    displayPrice: "$0",
    displayName: "Free",
  },
  {
    id: "starter",
    name: "Starter",
    description: "For the ambitious beginner ready to level up",
    price: "$69",
    priceIntervalName: "per month",
    stripe_price_id: "price_1QqIjJExIMOSvg1Floz4tyON",
    stripe_price_id_annual: "price_1QqMWfExIMOSvg1Fit4MZbHo",
    stripe_product_id: "prod_RjmH0tLiIWL2IN",
    features: [
      "Everything in Free",
      "25 AI-powered interviews/month",
      "Detailed performance analytics",
      "Priority community support",
      "Monthly group coaching call",
    ],
    studentPlan: true,
    displayPrice: "$69",
    displayName: "Starter",
  },
  {
    id: "premium",
    name: "Premium",
    description: "For the determined achiever targeting top firms",
    price: "$129",
    priceIntervalName: "per month",
    stripe_price_id: "price_1QqO5rExIMOSvg1FwOnoMDP9",
    stripe_price_id_annual: "price_1QqO8NExIMOSvg1FR5DyAZeM",
    stripe_product_id: "prod_RjrpRh9ZWkRCsy",
    features: [
      "Everything in Starter",
      "Unlimited AI-powered interviews",
      "Advanced behavioral analysis",
      "Weekly group coaching calls",
      "1-on-1 coaching session/month",
      "Industry-specific prep tracks",
    ],
    studentPlan: true,
    displayPrice: "$129",
    displayName: "Premium",
    recommended: true,
  },
  {
    id: "elite",
    name: "Elite",
    description: "For the elite performer aiming for the absolute top",
    price: "$199",
    priceIntervalName: "per month",
    stripe_price_id: "price_1QqOI3ExIMOSvg1FA1m5K7Yf",
    stripe_price_id_annual: "price_1QqOI3ExIMOSvg1FYNU6HYYX",
    stripe_product_id: "prod_Rjs2wOaxR8o6k0",
    features: [
      "Everything in Premium",
      "Unlimited everything",
      "Weekly 1-on-1 coaching sessions",
      "Direct access to industry mentors",
      "Mock interview with real hiring managers",
      "Guaranteed interview improvement or money back",
      "Priority customer support",
    ],
    studentPlan: true,
    displayPrice: "$199",
    displayName: "Elite",
  },
]
